import styled from 'styled-components'

import { Image } from '@application/Interfaces/Atoms/Image'
import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Link } from '@src/Application/Interfaces/Atoms/Link'

export const Icon = styled(Image)`
    margin-bottom: 20px;
    max-width: 40px;
    transition: transform 0.5s linear 0s;
`

export const ItemTitle = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    margin-bottom: 10px;
    line-height: 180%;
`

export const ItemDescription = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    margin-bottom: 30px;
    line-height: 180%;
`

export const ReadMore = styled(Link)`
    display: flex;
    flex: 1;
    text-decoration: none;
    align-items: center;
    text-transform: uppercase;
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};

    svg {
        margin-left: 8px;
    }
`

export const Item = styled.div<{ $mode: ThemeModeType }>`
    &:hover,
    &:focus,
    &:active {
        ${Icon} {
            transform: translateY(-5px);
        }
    }

    ${ItemTitle}, ${ReadMore} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.p500)};
    }

    ${ItemDescription} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.g600)};
    }

    ${ReadMore} {
        &:hover,
        &:focus,
        &:active {
            color: ${(props) => props.theme.color.a500};

            svg path {
                fill: ${(props) => props.theme.color.a500};
                stroke: ${(props) => props.theme.color.a500};
            }
        }
    }
`
